module.exports = __webpack_public_path__ + "img/MapPicsSavannah.f964c896.webp";